import { IPresetLoader } from './IPresetLoader';
import { PresetData, ElementPresetData } from '@/models/presets';
import store from '@/store';
import Element from '@/models/element';
import { HandleBacksCommand } from '@/models/command/handleBacksCommand';
import { HandleLegsSupportCommand } from '@/models/command/handleLegsSupportCommand';

export class ClonePresetLoader implements IPresetLoader {

    private presetGroups: Map<string, ElementPresetData[]> = new Map();
    private loadedPresets: any[] = [];
    private data!: PresetData;
    private startTime: number;
    private first: boolean = true;
    private isIdle: boolean = true;

    constructor(
        private scenePreview: any,
    ) { }

    public load(data: PresetData) {
        if (this.isIdle) {
            this.isIdle = false;
            this.initialize(data);
            this.clearScene();
            this.restoreShaders();
            this.groupPresets();
            this.loadPresets();
        }
    }

    private initialize(data: PresetData) {
        this.startTime = performance.now();
        this.presetGroups.clear();
        this.loadedPresets = [];
        this.data = data;
    }

    private clearScene() {
        store.commit('setFrontsVisibility', true);
        this.scenePreview.elements.forEach((x) => x.remove());
        this.scenePreview.elements.splice(0, this.scenePreview.elements.length);
        this.scenePreview.scene.clearCachedVertexData();
    }

    private restoreShaders() {
        store.commit('restoreShaders', this.data.shaders);
    }

    private groupPresets() {
        this.data.elements.forEach((preset) => {
            const key = this.getKey(preset);
            if (this.presetGroups.has(key)) {
                const group = this.presetGroups.get(key);
                group.push(preset);
            } else {
                this.presetGroups.set(key, [preset]);
            }
        });
    }

    private loadPresets() {
        this.presetGroups.forEach((presets, key) => {
            const firstPreset = presets.shift();
            const shader = store.getters.shaderByName(firstPreset.shaderName);
            this.scenePreview.importModel(
                this.scenePreview.scene,
                firstPreset.model,
                firstPreset.light,
                shader,
                null,
                (element: Element) => {
                    this.onElementCreated(element, firstPreset);
                    presets.forEach((x) => {
                        const clonedElement = element.clone();
                        this.onElementCreated(clonedElement, x);
                        this.scenePreview.elements.push(clonedElement);
                    });
                },
            );
        });
    }

    private onElementCreated(element: Element, preset: ElementPresetData) {
        element.position = preset.position;
        element.shape = preset.shape;
        element.center = preset.center;
        element.rotation = preset.rotation;
        element.slot = preset.slot;
        this.onPresetLoaded(preset, element);
    }

    private onPresetLoaded(preset: ElementPresetData, element: Element) {
        this.loadedPresets.push({ preset, element });
        if (this.loadedPresets.length === this.data.elements.length) {
            this.loadedPresets.forEach((pair) => {
                const presetsToBind = pair.preset.bindings.map(
                    (i) => this.data.elements[i],
                );
                const elementsToBind = presetsToBind.map(
                    (p) => this.loadedPresets.find((l) => l.preset === p).element,
                );
                elementsToBind.forEach((e) => {
                    pair.element.bindings.push(e);
                });
            });
            const handleBacksCommand = new HandleBacksCommand(this.scenePreview);
            handleBacksCommand.execute();
            const handleLegsSupportCommand = new HandleLegsSupportCommand(this.scenePreview);
            handleLegsSupportCommand.execute();
            if (this.first) {
                store.commit('center');
                this.first = false;
            }
            this.isIdle = true;
            setTimeout(() => {
                // store.dispatch('sapCalculate');
                store.commit('hideLoadingScreen');
                // console.log(`
                //     Call to doSomething took
                //     ${(performance.now() - this.startTime)}
                //     milliseconds.
                // `);
            }, 1000);
        }
    }

    private getKey(preset: ElementPresetData): string {
        return `${preset.model}_${preset.shaderName}`;
    }
}
